import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../../pages/auth/services/auth.service';
import { getPermissionForRoutePath } from './route-permission.util';
import { AccessDeniedService } from '../../services/access-denied/access-denied.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const accessDeniedService = inject(AccessDeniedService);

  if (!authService.isLoggedIn()) {
    authService.urlToRedirectBack = state.url;
    router.navigate(['/login']);
    return false;
  }

  const requiredPermission = getPermissionForRoutePath(route.routeConfig?.path);

  if (requiredPermission && !authService.hasPermission(requiredPermission)) {
    accessDeniedService.show();
    return false;
  }

  return true;
};
